<template>
    <k-page>
        <template v-slot:header>
            <profile-header />
        </template>
        <k-container size="lg" class="pb-20 mt-8">
            <div v-if="data.result.items">
                <div class="lg:hidden grid md:grid-cols-2 gap-3">
                    <k-panel v-for="item in data.result.items" :key="item.uuid" class="bg-white px-2 py-2 border">
                        <div class="flex flex-row mb-4 pb-2 border-b items-center">
                            <div v-if="item.companyLogo" class="mr-2">
                                <img class="object-scale-down" style="height: 48px;"
                                     :src="`/api/guest/download/${item.companyLogo}`">
                            </div>
                            <div class="flex">
                                <div class="font-semibold text-sm">{{item.companyName}}</div>
                            </div>
                        </div>
                        <k-panel-row>
                            <div slot="left">{{ $t("countries")}}</div>
                            <div slot="right">
                                <k-country-flags slot="right" :countries="item.countries"></k-country-flags>
                            </div>
                        </k-panel-row>
                        <k-panel-row>
                            <div slot="left">{{ $t("industry")}}</div>
                            <div slot="right">
                                <div v-for="product in item.productTypes" class="text-right" v-bind:key="product">
                                    {{product}}&nbsp;
                                </div>
                            </div>
                        </k-panel-row>
                        <k-panel-row>
                            <div slot="left">{{ $t("kildeRating")}}</div>
                            <div slot="right">{{item.creditRating}}</div>
                        </k-panel-row>
                        <k-panel-row>
                            <div slot="left">{{ $t("loanOriginated")}}</div>
                            <div slot="right">{{item.loanOriginated | numeralFormat('$0,0.00')}}</div>
                        </k-panel-row>
                        <k-panel-row>
                            <div slot="left">{{ $t("loansPortfolio")}}</div>
                            <div slot="right">{{item.loanPortfolio | numeralFormat('$0,0.00')}}</div>
                        </k-panel-row>
                        <k-panel-row>
                            <div slot="left">{{ $t("borrowingOnKilde")}}</div>
                            <div slot="right">{{item.borrowingOnPlatform | numeralFormat('$0,0.00')}}</div>
                        </k-panel-row>
                        <k-panel-row>
                            <div slot="left">{{ $t("year")}}</div>
                            <div slot="right">{{item.foundedYear}}</div>
                        </k-panel-row>
                        <k-panel-row>
                            <div slot="right">
                                <router-link :to="`/borrower/${item.uuid}`">
                                    <a-button type="primary" ghost>
                                        {{ $t("view")}}
                                    </a-button>
                                </router-link>
                            </div>
                        </k-panel-row>
                    </k-panel>
                </div>
                <div class="hidden lg:block">
                    <table class="table-auto bg-white w-full">
                        <thead>
                        <tr class="text-sm bg-gray-100">
                            <th class="border px-4 py-2" style="min-width: 500px; max-width: 500px; width: 500px;">{{ $t("company")}}</th>
                            <th class="border px-2 py-2 text-center">{{ $t("kildeRating")}}</th>
                            <th class="border px-2 py-2 text-center">{{ $t("loanOriginated")}}</th>
                            <th class="border px-2 py-2 text-center">{{ $t("loansPortfolio")}}</th>
                            <th class="border px-2 py-2 text-center">{{ $t("borrowingOnKilde")}}</th>
                            <th class="border px-2 py-2 text-center">{{ $t("foundedYear")}}</th>
                            <th class="border px-2 py-2 text-center"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in data.result.items" :key="item.uuid" class="hover:bg-gray-100">
                            <td class="border px-4 py-4">
                                <div class="flex flex-row items-center">
                                    <div v-if="item.companyLogo" class="mr-2">
                                        <img class="object-scale-down" style="width: 100px;"
                                             :src="`/api/guest/download/${item.companyLogo}`">
                                    </div>
                                    <div class="ml-2">
                                        <div class="font-semibold text-sm">{{item.companyName}}</div>
                                        <div class="">
                                            <span v-for="(product, index) in item.productTypes"
                                                  v-bind:key="product"
                                                  class="text-xs text-gray-700">
                                                <span v-if="index > 0">&nbsp;&bull;&nbsp;</span><span>{{product}}</span>
                                            </span>
                                        </div>
                                        <div class="flex flex-row">
                                            <div class="mr-2 mt-1">
                                                <k-country-flags slot="right"
                                                                 :countries="item.countries"></k-country-flags>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="border px-2 py-4  whitespace-no-wrap text-center">
                                {{item.creditRating}}
                            </td>

                            <td class="border px-2 py-4 whitespace-no-wrap text-right">
                                {{item.loanOriginated | numeralFormat('$0,0.00')}}
                            </td>
                            <td class="border px-2 py-4 whitespace-no-wrap text-right">
                                {{item.loanPortfolio | numeralFormat('$0,0.00')}}
                            </td>
                            <td class="border px-2 py-4 whitespace-no-wrap text-right">
                                {{item.borrowingOnPlatform | numeralFormat('$0,0.00')}}
                            </td>
                            <td class="border px-2 py-4  whitespace-no-wrap text-center">
                                {{item.foundedYear}}
                            </td>
                            <td class="border px-1 py-4 text-center">
                                <router-link :to="`/borrower/${item.uuid}`">
                                    <a-button type="primary" ghost>
                                        {{ $t("view")}}
                                    </a-button>
                                </router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </k-container>
    </k-page>
</template>

<script>
    import ProfileHeader from '@investor/components/profile/ProfileHeader';

    export default {
        components: {
            ProfileHeader
        },
        data() {
            return {
                loading: false,
                data: {
                    result: {
                        items: [],
                        totalItems: 0
                    }
                },
                form: {
                    ordering: [{
                        field: 'company_name',
                        asc: true,
                    }],
                    page: 1,
                    pageSize: 1000,
                },
            }
        },
        async mounted() {
            await this.refresh();
        },
        methods: {
            async refresh() {
                let resp = await this.$post('borrowers-listing', this.form);
                this.data.result.items = resp.items;
            },
        }
    }
</script>


